import { BrowserRouter, Route, Routes } from "react-router-dom";
import useInactivityLogout from "../src/hook/useInactivityLogout"; // Adjust path
import RouteScrollToTop from "./helper/RouteScrollToTop";
import React, { useState } from "react";
// All page imports (unchanged)
import HomePageOne from "./pages/Auth/HomePageOne";
import SubadminPage from "./pages/SubAdmin/SubAdminListPage";
import AddSubadminPage from "./pages/SubAdmin/AddSubAdminPage";
import EditSubadminPage from "./pages/SubAdmin/EditSubadminPage";
import ViewSubadminPage from "./pages/SubAdmin/ViewSubadminPage";
import SignInPage from "./pages/Auth/SignInPage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import OTPPage from "./pages/Auth/OTPPage";
import ResetPasswordPage from "./pages/Auth/ResetPassword";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import ViewProfilePage from "./pages/Auth/ViewProfilePage";
import DengerAlert from "../src/components/child/Alert/DengerAlert";
import ViewCategoryPage from "./pages/Categories/ViewCategoryPage";
import ViewAddCategoryPage from "./pages/Categories/ViewAddCategoryPage";
import ViewEditCategoryPage from "./pages/Categories/ViewEditCategoryPage";
import UserList from "./pages/User/UserList";
import ViewUserPage from "./pages/User/ViewUserPage";
import EditUserPage from "./pages/User/EditUserPage";
import ViewFacilityPage from "./pages/Facilities/ViewFacilitiesPage";
import ViewAddFacilityPage from "./pages/Facilities/ViewAddFacilityPage";
import ViewEditFacilityPage from "./pages/Facilities/ViewEditFacilityPage";

import HostList from "./pages/Host/HostList";
import ViewHostPage from "./pages/Host/ViewHostPage";

import ClubList from "./pages/Club/ClubList";
import ViewClubPage from "./pages/Club/ViewClubPage";
import ViewuserClubPage from "./pages/User/ViewUserClubPage";
import ViewuserBookingPage from "./pages/User/ViewUserBookingPage";

import CMSList from "./pages/CMS/CMSList";
import ViewCMSPage from "./pages/CMS/ViewCMSPage";
import EditCMSPage from "./pages/CMS/EditCMSPage";

import HelpPage from "./pages/HelpSupport/HelpSupportList";
import ViewHelpPage from "./pages/HelpSupport/ViewHelpSupportPage";

import DiscountPage from "./pages/ManageDiscount/DiscountList";
import ViewDiscountPage from "./pages/ManageDiscount/ViewDiscountpage";
import UpdateDiscountPage from "./pages/ManageDiscount/DiscountUpdate";
import AddDiscountPage from "./pages/ManageDiscount/DiscountAdd";

import SettingPage from "./pages/Setting/SettingPage";

import ReviewList from "./pages/Review/ReviewList";
import ViewReviewPage from "./pages/Review/ViewReviewPage";

import BookingList from "./pages/Booking/BookingList";
import ViewBookingPage from "./pages/Booking/ViewBookingPage";

import PaymentList from "./pages/Payment/PaymentList";

import SendNotification from "./pages/notification/AddNotification";
import Notification from "./pages/notification/NotificationList";

import PromoterList from "./pages/Promoter/PromoterList";
import ViewPromoterPage from "./pages/Promoter/ViewPromoterPage";

import WebUser from "./pages/Web/webuserList";
import VenuePromotionRequestList from "./pages/VenuePromotionRequest/VenuePromotionRequestList";
import EventPromotionRequestList from "./pages/EventPromotionRequest/EventPromotionRequestList";
import PromoterPayoutList from "./pages/PromoterPayout/PromoterPayoutList";
import ViewPromoterPayoutPage from "./pages/PromoterPayout/ViewPromoterPayoutPage";

import GuestList from "./pages/GuestList/GuestList";
import ViewGuestList from "./pages/GuestList/ViewGuestList";
import JoinedGuestList from "./pages/JoinedGuest/JoinedGuestList";
import ViewJoinedGuest from "./pages/JoinedGuest/ViewJoinedGuest";
import ScannedGuestList from "./pages/ScannedGuest/ScannedGuestList";
import ViewScannedGuest from "./pages/ScannedGuest/ViewScannedGuest";

import PromoterBottleService from "./components/Promoter/PromoterBottleService";
import AdditionalBottleServiceList from "./components/Promoter/AdditionalBottleServiceList";
import AdditionalBottleServiceView from "./components/Promoter/AdditionalBottleServiceView";
import PromoterJoinedUsersList from "./components/Promoter/PromoterJoinedUsersList";
import PromoterVenuesList from "./components/Promoter/PromoterVenuesList";


// ✅ This is the component that includes useInactivityLogout (inside <BrowserRouter>)
function AppContent() {
  const [alertMessage, setAlertMessage] = useState(null);

  // Pass the alert function to the hook
  useInactivityLogout((message) => {
    setAlertMessage(message); // Set alert message
  });

  return (
    <>
      <RouteScrollToTop />
      {alertMessage && (
        <DengerAlert
          message={alertMessage}
          onClose={() => setAlertMessage(null)} // Clear alert on close
        />
      )}
      <Routes>
        {/* Auth */}
        <Route exact path="/" element={<SignInPage />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/forgotpassword" element={<ForgotPasswordPage />} />
        <Route exact path="/otpverify" element={<OTPPage />} />
        <Route exact path="/resetpassword" element={<ResetPasswordPage />} />

        <Route exact path="/dashboard" element={<HomePageOne />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        {/******** Sub Admin ***** */}
        <Route exact path="/subadmin" element={<SubadminPage />} />
        <Route
          exact
          path="/subadmin/add-Subadmin"
          element={<AddSubadminPage />}
        />
        <Route
          exact
          path="/subadmin/edit-Subadmin/:id?"
          element={<EditSubadminPage />}
        />
        <Route
          exact
          path="/subadmin/view-Subadmin/:id?"
          element={<ViewSubadminPage />}
        />

        {/******** Category Page ***** */}
        <Route exact path="/categories" element={<ViewCategoryPage />} />
        <Route path="/categories/add" element={<ViewAddCategoryPage />} />
        <Route path="/categories/edit/:id" element={<ViewEditCategoryPage />} />

        {/******** Facilities Page ***** */}
        <Route exact path="/facilities" element={<ViewFacilityPage />} />
        <Route path="/facility/add" element={<ViewAddFacilityPage />} />
        <Route path="/facility/edit/:id" element={<ViewEditFacilityPage />} />

        {/******** Club Page ***** */}
        <Route exact path="/club" element={<ClubList />} />
        <Route path="/club/view-club/:id" element={<ViewClubPage />} />

        {/******** Review Page ***** */}
        <Route exact path="/review" element={<ReviewList />} />
        <Route
          exact
          path="/review/view-review/:id?"
          element={<ViewReviewPage />}
        />

        {/******** Booking Page ***** */}
        <Route exact path="/booking" element={<BookingList />} />
        <Route
          exact
          path="/booking/view-booking/:id?"
          element={<ViewBookingPage />}
        />

        {/******** Payment  History ***** */}
        <Route exact path="/payment" element={<PaymentList />} />

        {/******** WebUser  ***** */}
        <Route exact path="/webuser" element={<WebUser />} />

        {/******** USER ***** */}
        <Route exact path="/user" element={<UserList />} />
        <Route exact path="/user/view-user/:id?" element={<ViewUserPage />} />
        <Route path="/promoter-bottle-service/:id" element={<PromoterBottleService />} />
        <Route
          path="/promoter/additional-bottle-service/:id"
          element={<AdditionalBottleServiceList />}
        />
        <Route
          path="/promoter/additional-bottle-service/view/:id/:transactionId"
          element={<AdditionalBottleServiceView />}
        />
        <Route exact path="/user/edit-user/:id?" element={<EditUserPage />} />
        <Route
          path="/user/view-userbooking/:id/:userid/"
          element={<ViewuserBookingPage />}
        />

        {/******** HOST ***** */}
        <Route exact path="/host" element={<HostList />} />
        <Route exact path="/host/view-host/:id?" element={<ViewHostPage />} />
        <Route
          path="/host/view-userclub/:id/:userid/"
          element={<ViewuserClubPage />}
        />

        {/******** Promoter ***** */}
        <Route exact path="/promoter" element={<PromoterList />} />
        <Route exact path="/promoter/view-promoter/:id?" element={<ViewPromoterPage />} />
        <Route
          path="/promoter/joined-users/:id"
          element={<PromoterJoinedUsersList />}
        />
        <Route
          path="/promoter/venues/:id"
          element={<PromoterVenuesList />}
        />


        {/******** Help & Support ***** */}
        <Route exact path="/help" element={<HelpPage />} />
        <Route exact path="/help/view-help/:id?" element={<ViewHelpPage />} />

        {/******** CMS ***** */}
        <Route exact path="/cms" element={<CMSList />} />
        <Route exact path="/cms/view-cms/:id?" element={<ViewCMSPage />} />
        <Route exact path="/cms/edit-cms/:id?" element={<EditCMSPage />} />

        {/******** Manage Discount ***** */}
        <Route exact path="/discount" element={<DiscountPage />} />
        <Route
          exact
          path="/discount/view-discount/:id?"
          element={<ViewDiscountPage />}
        />
        <Route
          exact
          path="/discount/edit-discount/:id?"
          element={<UpdateDiscountPage />}
        />
        <Route
          exact
          path="/discount/add-discount"
          element={<AddDiscountPage />}
        />

        {/******** Notification ***** */}
        <Route exact path="/notification" element={<Notification />} />
        <Route exact path="/notification/sent" element={<SendNotification />} />

        {/******** Venue Promotion Request (type=host) ***** */}
        <Route
          exact
          path="/venue-promotion-request"
          element={<VenuePromotionRequestList />}
        />

        {/******** Event Promotion Request (type=event) ***** */}
        <Route
          exact
          path="/event-promotion-request"
          element={<EventPromotionRequestList />}
        />

        {/******** Promoter Payout Management ***** */}
        <Route exact path="/promoter-payout" element={<PromoterPayoutList />} />
        <Route
          exact
          path="/promoter-payout/view-payout/:id?"
          element={<ViewPromoterPayoutPage />}
        />

        {/* *********** Guest List ************ */}
        <Route exact path="/guestList" element={<GuestList />} />
        <Route
          exact
          path="/guestList/view-guestList/:id"
          element={<ViewGuestList />}
        />

        {/* *********** Joined Guest List ************ */}
        <Route exact path="/joinedGuest" element={<JoinedGuestList />} />
        <Route exact path="/joinedGuest/view-guest/:id" element={<ViewJoinedGuest />} />

        {/* *********** Scanned Guest List ************ */}
        <Route exact path="/scannedGuest" element={<ScannedGuestList />} />
        <Route exact path="/scannedGuest/view-guest/:id" element={<ViewScannedGuest />} />

        {/******** Setting ***** */}
        <Route exact path="/setting" element={<SettingPage />} />

        {/* *********** Extra PAges ************ */}
        <Route exact path="/coming-soon" element={<ComingSoonPage />} />
        <Route exact path="/access-denied" element={<AccessDeniedPage />} />
        <Route exact path="/maintenance" element={<MaintenancePage />} />
        <Route exact path="/blank-page" element={<BlankPagePage />} />
        {/* <Route exact path='*' element={<ErrorPage />} /> */}
        <Route exact path="*" element={<ComingSoonPage />} />
      </Routes>
    </>
  );
}

// ✅ Main app entry that wraps everything in <BrowserRouter>
function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
    // <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
    //   <AppContent />
    // </BrowserRouter>
  );
}

export default App;
